import '../sass/blog-section-block.scss';
import './blog-section-block';
